import { Injectable, inject } from '@angular/core';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { MFA_SETUPLATER_TIMESTAMP } from '../login-modal/constants/login-constant';
import { loginAndGetDashboardResponse } from '../login-modal/models/login-authentication-screen.interface';
import { FlowRouterService } from '../login-modal/services/flow-router.service';

@Injectable({
  providedIn: 'root'
})
export class MfaUtilService {
  flowRouter = inject(FlowRouterService);

  validateMFARedirection(
    authenticationConfig?: OauthAEMConfig,
    response?: loginAndGetDashboardResponse
  ): boolean {
    return !!(
      this.checkMfaUrls(authenticationConfig) &&
      response?.hasEmail &&
      this.checkForMfaFlow(authenticationConfig) &&
      !(localStorage.getItem('mfaSetupLater') === 'true')
    );
  }

  timeStampExpiry(authenticationConfig?: OauthAEMConfig) {
    if (authenticationConfig && authenticationConfig.MFA_SETUP_LATER_TIMER) {
      this.getExpiry(authenticationConfig.MFA_SETUP_LATER_TIMER);
    }
  }

  getExpiry(timer: number) {
    const getDate = localStorage.getItem('mfaSetupLaterTimeStamp');
    if (getDate) {
      const expiryDate = JSON.parse(getDate) + MFA_SETUPLATER_TIMESTAMP * timer;
      if (Date.now() > expiryDate) {
        localStorage.removeItem('mfaSetupLaterTimeStamp');
        localStorage.removeItem('mfaSetupLater');
      }
    }
  }

  checkMfaUrls(authenticationConfig?: OauthAEMConfig) {
    const mfaUrls = authenticationConfig?.MFA_URLS ?? [];
    return (
      (window.location.pathname === '/' ||
        mfaUrls.some((item) => window.location.href?.includes(item))) ??
      false
    );
  }

  checkForMfaFlow(authenticationConfig?: OauthAEMConfig): boolean {
    return !!(
      authenticationConfig?.MFA_FLOW &&
      this.flowRouter.setupMfaFlowRouter$.getValue()
    );
  }
}
